var React = require('react');

function IconChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeMiterlimit":"10","strokeWidth":"5","stroke":"currentColor","d":"M6 3l18 18L6 39"}));
}

IconChevron.defaultProps = {"viewBox":"0 0 26 42"};

module.exports = IconChevron;

IconChevron.default = IconChevron;
